import { h, Host } from "@stencil/core";
/**
 * @slot (default) - Content of the sidebar
 */
export class AppHeader {
    constructor() {
        this.baseClass = "uxc-app-sidebar-notifications";
        this.opened = false;
        this.side = "right";
        this.alignHeader = true;
        this.alignFooter = false;
    }
    componentDidLoad() {
        this.appSidebarNotificationsEvent.emit();
    }
    render() {
        const { baseClass, opened, side, alignHeader, alignFooter } = this;
        return (h(Host, { key: 'd861539acabcd37c585374394a8f66e6fad98264', class: {
                [`${baseClass}`]: true
            } }, h("uic-sidebar", { key: 'fc74064f7dc022372b0a80f08d57a3b068c01d9e', opened: opened, side: side, alignHeader: alignHeader, alignFooter: alignFooter }, h("div", { key: 'c593c2c3f189c27dc7e245f4ae353376feb05f31', class: `${baseClass}__inner` }, h("slot", { key: 'a4ac774084a3289a3698d460d0b26dc43fd9e617' })))));
    }
    static get is() { return "uxc-app-sidebar-notifications"; }
    static get originalStyleUrls() {
        return {
            "$": ["app-sidebar-notifications.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["app-sidebar-notifications.css"]
        };
    }
    static get properties() {
        return {
            "opened": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Flag that indicates if the app sidebar notification is opened or not"
                },
                "attribute": "opened",
                "reflect": false,
                "defaultValue": "false"
            },
            "side": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "\"left\" | \"right\"",
                    "resolved": "\"left\" | \"right\"",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "On which side should the sidebar be positioned"
                },
                "attribute": "side",
                "reflect": false,
                "defaultValue": "\"right\""
            },
            "alignHeader": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Flag that indicates if the sidebar top should be aligned with a header"
                },
                "attribute": "align-header",
                "reflect": false,
                "defaultValue": "true"
            },
            "alignFooter": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Flag that indicates if the sidebar bottom should be aligned with a footer"
                },
                "attribute": "align-footer",
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
    static get events() {
        return [{
                "method": "appSidebarNotificationsEvent",
                "name": "uicAppSidebarNotifications",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Emitted when the sidebar is loaded. This event informs the app header that\nthe notification bell icon controls the opened state of the sidebar."
                },
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                }
            }];
    }
    static get elementRef() { return "element"; }
}
//# sourceMappingURL=app-sidebar-notifications.js.map
